import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import _ from 'lodash'
import { Row, Col } from 'react-flexbox-grid'
import { Collapse } from 'react-bootstrap'
import Search from './filters/search'
import ViewType from './filters/view_type'
import AdvancedFiltersToggle from './filters/advanced_filters_toggle'
import TourFilter from './filters/tour_filter'
import EventStatusFilter from './filters/event_status_filter'
import StartDateFilter from './filters/start_date_filter'
import EndDateFilter from './filters/end_date_filter'
import LocationFilter from './filters/location_filter'

class DirectoriesFiltersComponent extends Component {
  render() {
    const {viewType, advancedFiltersOn, changeFilter, dataIsLoading, toursOptions, showTours, selectedTour, leagueName, selectedEventStatus, statusFilterVisible,
      startDate, endDate, location, showLocationFilter, currentLocation, metricUnits, shouldShowLotteryFilter, customerDateFormat,
    } = this.props
    let colSize

    showTours ? colSize = 3 : colSize = 4
    
    const tourDisabled = false
    return <div className="categories-filters"><Row className={'padding-0'}><Col xs={12} sm={1} md={1} lg={1} xl={1} className={'hidden-directories-xs'}><AdvancedFiltersToggle open={ advancedFiltersOn } onChange={ changeFilter } disabled={ dataIsLoading }></AdvancedFiltersToggle></Col><Col className={'hidden-xs'} md={1} mdOffset={1} lg={2}></Col><Col xs={12} sm={3} smOffset={1} mdOffset={0} md={3} lg={2} xl={2} className="view-types-and-toggle hidden-directories-xs"><Col sm={7} smOffset={3} md={7} mdOffset={0} xs={8} className="view-types-and-toggle hidden-directories-xs"><ViewType viewType={ viewType } onChange={ changeFilter } disabled={ dataIsLoading}></ViewType></Col></Col><Col xs={4} sm={1} md={1} lg={5} xl={6} className={'visible-directories-xs add-margin-top-5'}><AdvancedFiltersToggle open={ advancedFiltersOn } onChange={ changeFilter } disabled={ dataIsLoading }></AdvancedFiltersToggle></Col><Col xs={8} sm={7} md={6} lg={5} xl={6}><Search value={ leagueName } onChange={ changeFilter }></Search></Col></Row><Collapse in={ advancedFiltersOn }><div className="transition-wrapper"><Row className="padding-0"><Col xs={12} sm={colSize} md={colSize} lg={true}><EventStatusFilter values={ selectedEventStatus} onChange={ changeFilter } statusFilterVisible={statusFilterVisible} showTours={ showTours } shouldShowLotteryFilter={shouldShowLotteryFilter}></EventStatusFilter></Col>{showTours && <Col xs={12} sm={colSize} md={colSize} lg={true}><TourFilter toursOptions={ toursOptions } value={ selectedTour } onChange={ changeFilter } disabled={ tourDisabled }></TourFilter></Col>}<Col xs={6} sm={colSize} md={colSize} lg={true}><StartDateFilter onChange={ changeFilter } value={startDate} customerDateFormat={customerDateFormat}></StartDateFilter></Col><Col xs={6} sm={colSize} md={colSize} lg={true}><EndDateFilter onChange={ changeFilter } value={endDate} customerDateFormat={customerDateFormat}></EndDateFilter></Col></Row><Row className="padding-0"><LocationFilter onChange={ changeFilter } value={location} allDataIsLoading={tourDisabled} showLocationFilter={showLocationFilter} currentLocation={currentLocation} metricUnits={metricUnits}></LocationFilter></Row></div></Collapse></div>
  }
}

DirectoriesFiltersComponent.propTypes = {
  viewType: PropTypes.string,
  advancedFiltersOn: PropTypes.bool,
  changeFilter: PropTypes.func.isRequired,
  dataIsLoading: PropTypes.bool,
  allDataIsLoading: PropTypes.bool,
  toursOptions: PropTypes.array,
  showTours: PropTypes.bool,
  selectedTour: PropTypes.string,
  leagueName: PropTypes.string,
  selectedEventStatus: PropTypes.array,
  statusFilterVisible: PropTypes.object,
  MRMember: PropTypes.object,
  startDate: PropTypes.number,
  endDate: PropTypes.number,
  location: PropTypes.object,
  showLocationFilter: PropTypes.bool,
  currentLocation: PropTypes.string,
  metricUnits: PropTypes.string,
  customerDateFormat: PropTypes.string,
  shouldShowLotteryFilter: PropTypes.bool,
}

export default DirectoriesFiltersComponent
